// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__15mJk","active":"Item_active__2lPVh","head":"Item_head__3H07W","body":"Item_body__2P3b5","category":"Item_category__1-XU8"};